class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



function updateFreeShippingProgress() {
  const progress = document.getElementById('FreeShippingProgress');
  if (!progress) return;

  const threshold = Number(progress.dataset.threshold || 15000);

  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((cart) => {
      const total = Number(cart.total_price || 0);
      const remaining = Math.max(threshold - total, 0);
      const percent = Math.min((total / threshold) * 100, 100);

      progress.dataset.cartTotal = total;

      const message = progress.querySelector(
        '.free-shipping-progress__message'
      );

      const bar = progress.querySelector(
        '.free-shipping-progress__bar'
      );

      if (message) {
        if (remaining > 0) {
          const formattedRemaining = new Intl.NumberFormat(
            document.documentElement.lang || 'en',
            {
              style: 'currency',
              currency: cart.currency || 'EUR'
            }
          ).format(remaining / 100);

          message.innerHTML =
            `You're <strong>${formattedRemaining}</strong> away from <strong>free shipping!</strong>`;
        } else {
          message.innerHTML =
            `<strong>You've unlocked free shipping!</strong>`;
        }
      }

      if (bar) {
  bar.style.setProperty(
    'width',
    `${percent}%`,
    'important'
  );
}

    })
    .catch((error) => {
      console.error('Free shipping progress error:', error);
    });
}


/* Initial load */
document.addEventListener('DOMContentLoaded', () => {
  updateFreeShippingProgress();
});


/* Shopify cart updates */
document.addEventListener('cart:updated', () => {
  setTimeout(updateFreeShippingProgress, 100);
});


/*
  Dawn quantity/remove updates.
  Cart drawer markup gets re-rendered,
  so we observe the drawer and recalculate.
*/
const freeShippingObserver = new MutationObserver(() => {
  clearTimeout(window.freeShippingUpdateTimer);

  window.freeShippingUpdateTimer = setTimeout(() => {
    updateFreeShippingProgress();
  }, 150);
});

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('CartDrawer');

  if (drawer) {
    freeShippingObserver.observe(drawer, {
      childList: true,
      subtree: true
    });
  }
});


/* =====================================
   CART UPSELL DRAG / SWIPE
===================================== */

let upsellDragState = null;

document.addEventListener('pointerdown', function (event) {
  const slider = event.target.closest('.cart-upsell__products');

  if (!slider) return;

  /* Don't start dragging when interacting with controls */
  if (
    event.target.closest(
      'button, select, option, a, input, label'
    )
  ) {
    return;
  }

  upsellDragState = {
    slider: slider,
    startX: event.clientX,
    scrollLeft: slider.scrollLeft
  };

  slider.classList.add('is-dragging');

  slider.setPointerCapture?.(event.pointerId);
});

document.addEventListener('pointermove', function (event) {
  if (!upsellDragState) return;

  const distance =
    event.clientX - upsellDragState.startX;

  upsellDragState.slider.scrollLeft =
    upsellDragState.scrollLeft - distance;
});

document.addEventListener('pointerup', function () {
  if (!upsellDragState) return;

  upsellDragState.slider.classList.remove(
    'is-dragging'
  );

  upsellDragState = null;
});

document.addEventListener('pointercancel', function () {
  if (!upsellDragState) return;

  upsellDragState.slider.classList.remove(
    'is-dragging'
  );

  upsellDragState = null;
});


/* =====================================
   CART UPSELL DESKTOP ARROWS
===================================== */

document.addEventListener('click', function (event) {

  const prevButton =
    event.target.closest('.cart-upsell__arrow--prev');

  const nextButton =
    event.target.closest('.cart-upsell__arrow--next');

  if (!prevButton && !nextButton) {
    return;
  }

  const upsell =
    event.target.closest('.cart-upsell');

  if (!upsell) {
    return;
  }

  const slider =
    upsell.querySelector('.cart-upsell__products');

  const card =
    upsell.querySelector('.cart-upsell__product');

  if (!slider || !card) {
    return;
  }

  const sliderStyles =
    window.getComputedStyle(slider);

  const gap =
    parseFloat(sliderStyles.columnGap || sliderStyles.gap || 0);

  const scrollAmount =
    card.getBoundingClientRect().width + gap;

  slider.scrollBy({
    left: prevButton ? -scrollAmount : scrollAmount,
    behavior: 'smooth'
  });

});


/* =====================================
   CART UPSELL ADD TO CART
===================================== */

document.addEventListener('change', function (event) {
  const variantSelect =
    event.target.closest('.cart-upsell__variant');

  if (!variantSelect) return;

  const card =
    variantSelect.closest('.cart-upsell__product');

  if (!card) return;

  const selectedOption =
    variantSelect.options
      ? variantSelect.options[variantSelect.selectedIndex]
      : null;

  const priceElement =
    card.querySelector('.cart-upsell__price');

  if (
    selectedOption &&
    selectedOption.dataset.price &&
    priceElement
  ) {
    const cents =
      Number(selectedOption.dataset.price);

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        const formattedPrice =
          new Intl.NumberFormat(
            document.documentElement.lang || 'en',
            {
              style: 'currency',
              currency: cart.currency || 'EUR'
            }
          ).format(cents / 100);

        priceElement.textContent =
          formattedPrice;
      })
      .catch(() => {});
  }
});


document.addEventListener('click', async function (event) {

  const addButton =
    event.target.closest('.cart-upsell__add');

  if (!addButton) return;

  const card =
    addButton.closest('.cart-upsell__product');

  if (!card) return;

  const variantInput =
    card.querySelector('.cart-upsell__variant');

  const message =
    card.querySelector('.cart-upsell__message');

  if (!variantInput) return;

  const variantId =
    Number(variantInput.value);

  if (!variantId) {
    if (message) {
      message.textContent =
        'Please select an option.';
    }

    return;
  }

  const originalText =
    addButton.textContent;

  addButton.disabled = true;
  addButton.textContent = 'Adding...';

  if (message) {
    message.textContent = '';
  }

  try {

    const response =
      await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            'Accept':
              'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ]
          })
        }
      );

    const result =
      await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Could not add product.'
      );
    }

    addButton.textContent =
      'Added';

    if (message) {
      message.textContent =
        'Added to cart.';
    }

    /* Refresh cart drawer + cart bubble */

    const sectionResponse =
      await fetch(
        `${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`
      );

    const sections =
      await sectionResponse.json();

    const cartDrawer =
      document.querySelector('cart-drawer');

    if (
      cartDrawer &&
      sections['cart-drawer']
    ) {

      const drawerHTML =
        new DOMParser()
          .parseFromString(
            sections['cart-drawer'],
            'text/html'
          )
          .querySelector('#CartDrawer');

      const currentDrawer =
        document.getElementById(
          'CartDrawer'
        );

      if (
        drawerHTML &&
        currentDrawer
      ) {
        currentDrawer.innerHTML =
          drawerHTML.innerHTML;
      }
    }

  if (sections['cart-icon-bubble']) {

  const bubbleDocument =
    new DOMParser().parseFromString(
      sections['cart-icon-bubble'],
      'text/html'
    );

  const newBubble =
    bubbleDocument.querySelector(
      '#cart-icon-bubble'
    );

  const currentBubble =
    document.getElementById(
      'cart-icon-bubble'
    );

  if (
    newBubble &&
    currentBubble
  ) {
    currentBubble.replaceWith(
      newBubble
    );

    if (cartDrawer) {
      cartDrawer.setHeaderCartIconAccessibility();
    }
  }
}



    /* Recalculate free shipping */
    setTimeout(() => {
      updateFreeShippingProgress();
    }, 150);

    /* Keep drawer open */
    if (cartDrawer) {
      cartDrawer.classList.add(
        'animate',
        'active'
      );
    }

  }

  catch (error) {

    console.error(
      'Cart upsell add error:',
      error
    );

    if (message) {
      message.textContent =
        error.message ||
        'Something went wrong.';
    }

    addButton.disabled = false;
    addButton.textContent =
      originalText;

  }

});